import React from "react";
import { string, func } from "prop-types";
import { Row, Button } from "react-bootstrap";

const ScoreReportNav = ({ handleReportNavTab, testId, tabToDisplay }) => {
  let tabs = null;

  switch (testId) {
    case "15":
      tabs = [
        <Button
          key={testId}
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === testId}
          onClick={() => handleReportNavTab(testId)}
        >
          CSAP
        </Button>,
        <Button
          key="24"
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === "24"}
          onClick={() => handleReportNavTab("24")}
        >
          SalesAP
        </Button>,
      ];
      break;
    case "24":
      tabs = [
        <Button
          key={testId}
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === testId}
          onClick={() => handleReportNavTab(testId)}
        >
          SalesAP
        </Button>,
        <Button
          key="15"
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === "15"}
          onClick={() => handleReportNavTab("15")}
        >
          CSAP
        </Button>,
      ];
      break;
    case "48":
      tabs = [
        <Button
          key="48"
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === testId}
          onClick={() => handleReportNavTab(testId)}
        >
          Illustrait
        </Button>,
        <Button
          key="workStyles"
          variant="link"
          className="dynamic-score-report-nav-tab"
          active={tabToDisplay === "workStyles"}
          onClick={() => handleReportNavTab("workStyles")}
        >
          Work Styles Report
        </Button>,
      ];
      break;
    default:
      return tabs;
  }

  return <Row className="dynamic-score-report-nav-bar">{tabs}</Row>;
};

ScoreReportNav.propTypes = {
  handleReportNavTab: func.isRequired,
  testId: string.isRequired,
  tabToDisplay: string.isRequired,
};

export default ScoreReportNav;
